import {
  commonValidationSchemas,
  createValidationSchema,
  type TSchema,
} from 'infrastructure/functions';

export const manualInteractiveTimeSchema = () =>
  createValidationSchema({
    time: commonValidationSchemas.number({ required: true }).min(0).max(60),
    comment: commonValidationSchemas.string({ required: true }),
  });

export type Values = TSchema<ReturnType<typeof manualInteractiveTimeSchema>>;
